import type { CountryIso } from "~/types";

const ukElgibileNationalities: CountryIso[] = [
  "ATG",
  "ARG",
  "AUS",
  "BHS",
  "BRB",
  "BLZ",
  "BWA",
  "BRA",
  "BRN",
  "CAN",
  "CHL",
  "CRI",
  "GRD",
  "GTM",
  "GUY",
  "HKG",
  "ISR",
  "JPN",
  "KIR",
  "MAC",
  "MYS",
  "MDV",
  "MHL",
  "MUS",
  "MEX",
  "FSM",
  "NRU",
  "NZL",
  "NIC",
  "PLW",
  "PAN",
  "PNG",
  "PRY",
  "PER",
  "WSM",
  "SYC",
  "SGP",
  "SLB",
  "KOR",
  "KNA",
  "LCA",
  "VCT",
  "TWN",
  "TON",
  "TTO",
  "TUV",
  "USA",
  "URY",
];

export default ukElgibileNationalities;